import type { FC } from "react";

import { CustomButton } from "@/components/atoms";

interface ConfirmOverlayProps {
  title: string;
  body: string;
  confirmLabel: string;
  confirmVariant?: "destructive" | "default";
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmOverlay: FC<ConfirmOverlayProps> = ({
  title,
  body,
  confirmLabel,
  confirmVariant = "destructive",
  onCancel,
  onConfirm,
}) => (
  <div
    className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40"
    onPointerDown={e => e.stopPropagation()}
    onClick={e => e.stopPropagation()}
  >
    <div
      className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 flex flex-col gap-4"
      onPointerDown={e => e.stopPropagation()}
      onClick={e => e.stopPropagation()}
    >
      <h2 className="text-lg font-bold">{title}</h2>
      <p className="text-sm text-gray-500">{body}</p>
      <div className="flex gap-3">
        <CustomButton
          variant="light"
          className="flex-1"
          type="button"
          onClick={onCancel}
          data-testid="confirm-overlay-cancel"
        >
          Cancel
        </CustomButton>
        <CustomButton
          variant={confirmVariant}
          className="flex-1"
          type="button"
          onClick={onConfirm}
          data-testid="confirm-overlay-confirm"
        >
          {confirmLabel}
        </CustomButton>
      </div>
    </div>
  </div>
);

export default ConfirmOverlay;
